import {QueryClient, QueryCache} from "@tanstack/vue-query";
import {useAlertStore} from "@/stores/alerts-store";
import {ApiError} from "@/helpers/api-error";

export function createVueQueryClient() {
    const handleError = (error: unknown) => {
        if (!(error instanceof ApiError)) return;
        // Validation errors are always shown inline by the component — never toast them
        if (error.isValidation) return;
        const alertStore = useAlertStore();
        alertStore.addError(error.problem.title ?? "Error", error.userMessage);
    };

    return new QueryClient({
        queryCache: new QueryCache({
            onError: (error, query) => {
                // Background refetch failed — stale data still showing, toast the error
                if (query.state.data !== undefined) {
                    handleError(error);
                }
                // First-load errors (data undefined) → component handles inline via SkeletonLoader
            },
        }),
        // No MutationCache — consumers handle mutation errors via reactive `error` ref (FormAlert)
        // or explicit `onError` callbacks (toast for one-shot actions)
        defaultOptions: {
            queries: {
                retry: false,
                // Don't auto-refetch just because the tab/window regained focus.
                // Cached data stays on screen until something explicit refetches it
                // (initial mount, route navigation, or a mutation invalidating the key).
                refetchOnWindowFocus: false,
            },
        },
    });
}
